import { render, staticRenderFns } from "./imgComp.vue?vue&type=template&id=2e632267"
import script from "./imgComp.vue?vue&type=script&lang=js"
export * from "./imgComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports